import React from 'react';
import PropTypes from 'prop-types';
import { flushStepCounter } from '../components/BookingStep';
import PagerContainer from './PagerContainer';

class BookingStepsContainer extends React.Component {
  componentDidUpdate(prevProps) {
    const children = BookingStepsContainer.getChildren(this.props);
    if (prevProps.appearance.totalSteps !== children.length) {
      this.props.actions.updateTotalSteps(children.length);
    }
  }

  static getChildren(props) {
    /* eslint-disable function-paren-newline */
    return (
      props.children &&
      props.children.filter(
        // Hide only those components, which have static method to control their present
        // and result is false.
        // @see App.js, Because of ExtraServicesContainer is inside div, we have to do this ugly stuff.
        c => c.type && ((c.type.show && c.type.show(c.props)) || !c.type.show)
      )
    );
    /* eslint-enable function-paren-newline */
  }

  render() {
    flushStepCounter();

    const children = BookingStepsContainer.getChildren(this.props);

    const allProps = {
      dispatchScrollToInvalid: this.props.dispatchScrollToInvalid,
      nextStep: this.props.actions.nextStep,
      currentStep: this.props.appearance.pagerIndex,
      prevStep: this.props.actions.prevStep,
      steps: children,
      totalSteps: this.props.appearance.totalSteps,
    };

    return (
      <div>
        <PagerContainer {...allProps} />
        <div className="booking-steps">
          {this.props.appearance.isNarrow &&
            children[this.props.appearance.pagerIndex - 1]}
          {!this.props.appearance.isNarrow && children}
        </div>
        {allProps.currentStep !== allProps.totalSteps && (
          <PagerContainer
            {...allProps}
            additionalClassName="booking-steps-pager--hero"
          />
        )}
      </div>
    );
  }
}

BookingStepsContainer.PropTypes = {
  actions:PropTypes.object.isRequired,
  appearance:PropTypes.object.isRequired,
  children:PropTypes.node,
};

export default BookingStepsContainer;
